import React from 'react';
import DataTable from '../../components/dataTable';
import {formatDateTimeColumn} from '../../helpers/excel-helper';
import {canSeeAuditFields} from '../../helpers/auth';

const DeviceTable = (props) => {
    const {
        removeRegister,
        attributes,
        permissions,
        list,
        loading,
        timezone,
        intl,
        auth,
        isAdministrator,
        onPressAdd,
        onPressEdit,
        onPressAccumulator,
        onPressFines,
        excelData,
    } = props;

    const showAuditFields = canSeeAuditFields(auth?.profile);

    // Esta tabela também é renderizada fora do painel administrativo. Sem o recorte, um usuário
    // de subcliente enxergaria o nome da central dona do dispositivo, e só o administrador vê.
    const ownershipColumns = isAdministrator ? [
        {title: 'deviceOwnerCustomer', field: 'ownerCustomerName', dataSort: true, width: 410},
    ] : [];

    // Criador/e-mail/datas: admin e central veem, fleet e client não.
    const auditColumns = showAuditFields ? [
        {title: 'sharedCreatedBy', field: 'createdByName', dataSort: true, width: 310},
        {title: 'sharedCreatorEmail', field: 'createdByEmail', dataSort: true, width: 330},
        {title: 'sharedCreatedAt', field: 'createdAtFormatted', dataSort: true, width: 210},
        {title: 'sharedUpdatedAt', field: 'updatedAtFormatted', dataSort: true, width: 210},
    ] : [];

    return (
        <DataTable
            auth={auth}
            add={onPressAdd}
            edit={onPressEdit}
            remove={removeRegister}
            list={list}
            loading={loading}
            attributes={attributes}
            permissions={permissions}
            accumulatorForm={onPressAccumulator}
            finesForm={onPressFines}
            keyField={'id'}
            excelData={excelData}
            confirmText={intl.formatMessage({id: 'deviceRemoveConfirm'})}
            headers={[
                {title: 'sharedName', field: 'name', dataSort: true, width: 460},
                {title: 'deviceImei', field: 'uniqueId', dataSort: true, width: 190},
                {title: 'deviceModel', field: 'model', dataSort: true, width: 130},
                {title: 'groupDialog', field: 'groupName', dataSort: true, width: 180},
                {title: 'sharedDisabled', field: 'disabled', dataSort: true, width: 150},
                {title: 'sharedCustomer', field: 'customerName', dataSort: true, width: 330},
                ...ownershipColumns,
                ...auditColumns,
            ]}
            excelConfig={{
                fileName: 'deviceTitle',
                columns: [
                    {label: 'sharedName', field: 'name'},
                    {label: 'deviceImei', field: 'uniqueId'},
                    {label: 'deviceModel', field: 'model'},
                    {label: 'groupDialog', field: 'groupName'},
                    ...(isAdministrator ? [
                        {label: 'deviceOwnerCustomer', field: 'ownerCustomerName'},
                    ] : []),
                    ...(showAuditFields ? [
                        {label: 'sharedCreatedBy', field: 'createdByName'},
                        {label: 'sharedCreatorEmail', field: 'createdByEmail'},
                        {label: 'sharedCreatedAt', field: 'createdAtFormatted'},
                        {label: 'sharedUpdatedAt', field: 'updatedAtFormatted'},
                    ] : []),
                    {label: 'deviceCategory', field: 'category'},
                    {label: 'deviceContact', field: 'contact'},
                    {label: 'sharedDisabled', field: (col) => col.disabled ? intl.formatMessage({id: 'sharedYes'}) : intl.formatMessage({id: 'sharedNo'})},
                    {label: 'sharedPhone', field: 'phone'},
                    {label: 'devicePlate', field: 'attributes.plate'},
                    {label: 'deviceManufacturer', field: 'attributes.manufacturer'},
                    {label: 'deviceVehicleModel', field: 'attributes.vehicleModel'},
                    {label: 'deviceFuelType', field: 'attributes.fuelType'},
                    {label: 'deviceFuelConsumption', field: 'attributes.fuelConsumption'},
                    {label: 'deviceIccid', field: 'attributes.iccid'},
                    {label: 'deviceM2mProvider', field: 'attributes.m2mProvider'},
                    {label: 'deviceColor', field: 'attributes.color'},
                    {label: 'deviceYear', field: 'attributes.year'},
                    {label: 'deviceRenavam', field: (col) => col.hasOwnProperty('attributes.renavan') ? col['attributes.renavan'] : col['attributes.renavam']},
                    {label: 'deviceChassi', field: 'attributes.chassi'},
                    {label: 'deviceInstallationLocation', field: 'attributes.installationLocation'},
                    {label: 'deviceTechnician', field: 'attributes.technician'},
                    {label: 'devicePassword', field: 'attributes.devicePassword'},
                    {label: 'deviceLastUpdate', field: (col) => formatDateTimeColumn(col?.lastUpdate, timezone)},
                ],
            }}
        />
    );
};

export default DeviceTable;
